export default __webpack_public_path__ + "static/media/elevate-cbb-1.90c8c54e.png";